import _toConsumableArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import t from "../common/base-provider.js";
import { newInAppMessageFromJson as ut } from "../InAppMessage/in-app-message-factory.js";
import ue from "../models/braze-event.js";
import { isArray as D, isEqual as ii, validateValueIsFromEnum as ta } from "../util/code-utils.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import wt from "../InAppMessage/models/templated-in-app-message.js";
import pt from "./models/trigger.js";
import ot from "./models/trigger-events.js";
import { logger as E } from "../../shared-lib/index.js";
var gr = /*#__PURE__*/function (_t) {
  _inherits(gr, _t);
  var _super = _createSuper(gr);
  function gr(t, i, s, e, r) {
    var _this;
    _classCallCheck(this, gr);
    _this = _super.call(this), _this.tg = t, _this.ws = i, _this.j = s, _this.Cn = e, _this.ig = r, _this.tg = t, _this.ws = i, _this.j = s, _this.Cn = e, _this.ig = r, _this.sg = [], _this.eg = [], _this.hg = null, _this.ng = {}, _this.og = {}, _this.triggers = [], _this.lg = 0, _this.ag(), _this.gg();
    return _this;
  }
  _createClass(gr, [{
    key: "fg",
    value: function fg() {
      if (this.j) {
        this.hg = this.j.lt(s.ct.iE) || this.hg, this.ng = this.j.lt(s.ct.EE) || this.ng, this.og = this.j.lt(s.ct.aE) || this.og;
        for (var _t2 = 0; _t2 < this.triggers.length; _t2++) {
          var i = this.triggers[_t2];
          i.id && null != this.og[i.id] && i.ad(this.og[i.id]);
        }
      }
    }
  }, {
    key: "ag",
    value: function ag() {
      if (!this.j) return;
      this.lg = this.j.lt(s.ct.nE) || 0;
      var t = this.j.lt(s.ct.oE) || [],
        i = [];
      for (var _s = 0; _s < t.length; _s++) i.push(pt.qn(t[_s]));
      this.triggers = i, this.fg();
    }
  }, {
    key: "gg",
    value: function gg() {
      var t = this,
        i = function i(_i, s, e, r, h) {
          return function () {
            t.cg(_i, s, e, r, h);
          };
        },
        e = {};
      var _iterator = _createForOfIteratorHelper(this.triggers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t7 = _step.value;
          _t7.id && (e[_t7.id] = _t7);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var r = !1;
      for (var _t3 = 0; _t3 < this.triggers.length; _t3++) {
        var _s2 = this.triggers[_t3];
        if (_s2.id && null != this.ng[_s2.id]) {
          var _t4 = this.ng[_s2.id],
            h = [];
          for (var _r = 0; _r < _t4.length; _r++) {
            var n = _t4[_r],
              o = _s2.ud(n.Er || 0);
            if (o > 0) {
              var _t5 = void 0,
                _r2 = void 0;
              h.push(n), null != n.ug && (_t5 = n.ug), null != n.dg && ue.gE(n.dg) && (_r2 = ue.qn(n.dg));
              var l = [];
              if (n.pg && D(n.pg)) for (var _t6 = 0; _t6 < n.pg.length; _t6++) {
                var _i2 = e[n.pg[_t6]];
                null != _i2 && l.push(_i2);
              }
              this.eg.push(window.setTimeout(i(_s2, n.Er || 0, _t5, _r2, l), o));
            }
          }
          this.ng[_s2.id].length > h.length && (this.ng[_s2.id] = h, r = !0, 0 === this.ng[_s2.id].length && delete this.ng[_s2.id]);
        }
      }
      r && this.j && this.j.ft(s.ct.EE, this.ng);
    }
  }, {
    key: "mg",
    value: function mg() {
      if (!this.j) return;
      var t = [];
      for (var i = 0; i < this.triggers.length; i++) t.push(this.triggers[i].dt());
      this.lg = new Date().valueOf(), this.j.ft(s.ct.oE, t), this.j.ft(s.ct.nE, this.lg);
    }
  }, {
    key: "bg",
    value: function bg() {
      if (!this.j) return;
      (this.j.lt(s.ct.nE) || 0) > this.lg ? this.ag() : this.fg();
    }
  }, {
    key: "N",
    value: function N(t) {
      var i = !1;
      if (null != t && t.triggers) {
        this.ig.Lr(), this.fg();
        var e = {},
          r = {};
        this.triggers = [];
        for (var _s3 = 0; _s3 < t.triggers.length; _s3++) {
          var _h = pt.fromJson(t.triggers[_s3]);
          if (_h) {
            _h.id && null != this.og[_h.id] && (_h.ad(this.og[_h.id]), e[_h.id] = this.og[_h.id]), _h.id && null != this.ng[_h.id] && (r[_h.id] = this.ng[_h.id]);
            for (var _t8 = 0; _t8 < _h.sd.length; _t8++) if (_h.sd[_t8].kc(ot.qs, null)) {
              i = !0;
              break;
            }
            this.triggers.push(_h);
          }
        }
        ii(this.og, e) || (this.og = e, this.j && this.j.ft(s.ct.aE, this.og)), ii(this.ng, r) || (this.ng = r, this.j && this.j.ft(s.ct.EE, this.ng)), this.mg(), i && (E.info("Trigger with test condition found, firing test."), this.ve(ot.qs)), this.ve(ot.OPEN);
        var h = this.sg;
        var n;
        this.sg = [];
        for (var _t9 = 0; _t9 < h.length; _t9++) n = Array.prototype.slice.call(h[_t9]), this.ve.apply(this, _toConsumableArray(n));
      }
    }
  }, {
    key: "cg",
    value: function cg(t, i, s, e, r) {
      var _this2 = this;
      var h = function h(e) {
          _this2.fg();
          var r = new Date().valueOf();
          t.dd(i) || (!1 === navigator.onLine && t.type === pt._r.Br && e.imageUrl ? E.info("Not showing ".concat(t.type, " trigger action ").concat(t.id, " due to offline state.")) : t.nd(r) && _this2.wg(t, r, s) ? 0 === _this2.ws.sc() ? E.info("Not displaying trigger ".concat(t.id, " because neither automaticallyShowInAppMessages() nor subscribeToInAppMessage() were called.")) : (_this2.ws.L([e]), _this2.yg(t, r)) : E.info("Not displaying trigger ".concat(t.id, " because display time fell outside of the acceptable time window.")));
        },
        n = function n() {
          _this2.fg();
          var h = r.pop();
          if (null != h) if (_this2.Tg(h, i, s, e, r), h.dd(i)) {
            var _t10 = "Server aborted in-app message display, but the timeout on fallback trigger ".concat(h.id, " has already elapsed.");
            r.length > 0 && (_t10 += " Continuing to fall back."), E.info(_t10), n();
          } else {
            E.info("Server aborted in-app message display. Falling back to lower priority ".concat(h.type, " trigger action ").concat(t.id, "."));
            var _n = 1e3 * h.ed - (new Date().valueOf() - i);
            _n > 0 ? _this2.eg.push(window.setTimeout(function () {
              _this2.cg(h, i, s, e, r);
            }, _n)) : _this2.cg(h, i, s, e, r);
          }
        };
      var o, l, a;
      switch (t.type) {
        case pt._r.Br:
          if (o = ut(t.data), null == o) {
            E.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring."));
            break;
          }
          if (l = this.ig.Ki(o), l) {
            E.error(l), n();
            break;
          }
          h(o);
          break;
        case pt._r.md:
          if (a = wt.fromJson(t.data, h, n, i, t.Gr || 0), null == a) {
            E.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring."));
            break;
          }
          this.ig.Zi(a, s, e);
          break;
        default:
          E.error("Trigger ".concat(t.id, " was of unexpected type ").concat(t.type, ", ignoring."));
      }
    }
  }, {
    key: "ve",
    value: function ve(t) {
      var _this3 = this;
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var s = arguments.length > 2 ? arguments[2] : undefined;
      if (!ta(ot, t, "Cannot fire trigger action.", "TriggerEvents")) return;
      if (this.Cn && this.Cn.Yl()) return E.info("Trigger sync is currently in progress, awaiting sync completion before firing trigger event."), void this.sg.push(arguments);
      this.bg();
      var e = new Date().valueOf(),
        r = e - (this.hg || 0);
      var h = !0,
        n = !0;
      var o = [];
      for (var _s4 = 0; _s4 < this.triggers.length; _s4++) {
        var _r3 = this.triggers[_s4],
          _l = e + 1e3 * _r3.ed;
        if (_r3.nd(_l) && (null == _r3.startTime || _r3.startTime.valueOf() <= e) && (null == _r3.endTime || _r3.endTime.valueOf() >= e)) {
          var _s5 = !1;
          for (var _e = 0; _e < _r3.sd.length; _e++) if (_r3.sd[_e].kc(t, i)) {
            _s5 = !0;
            break;
          }
          _s5 && (h = !1, this.wg(_r3, _l, t) && (n = !1, o.push(_r3)));
        }
      }
      if (h) return void E.info("Trigger event ".concat(t, " did not match any trigger conditions."));
      if (n) return void E.info("Ignoring ".concat(t, " trigger event because a trigger was displayed ").concat(r / 1e3, "s ago."));
      o.sort(function (t, i) {
        return t.priority - i.priority;
      });
      var l = o.pop();
      null != l && (E.info("Firing ".concat(l.type, " trigger action ").concat(l.id, " from trigger event ").concat(t, ".")), this.Tg(l, e, t, s, o), 0 === l.ed ? this.cg(l, e, t, s, o) : this.eg.push(window.setTimeout(function () {
        _this3.cg(l, e, t, s, o);
      }, 1e3 * l.ed)));
    }
  }, {
    key: "changeUser",
    value: function changeUser() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      if (this.triggers = [], this.j && this.j.Nt(s.ct.oE), !t) {
        this.sg = [], this.hg = null, this.og = {}, this.ng = {};
        for (var _t11 = 0; _t11 < this.eg.length; _t11++) clearTimeout(this.eg[_t11]);
        this.eg = [], this.j && (this.j.Nt(s.ct.iE), this.j.Nt(s.ct.aE), this.j.Nt(s.ct.EE));
      }
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this.triggers = [], this.hg = null, this.og = {}, this.ng = {};
      for (var _t12 = 0; _t12 < this.eg.length; _t12++) clearTimeout(this.eg[_t12]);
      this.eg = [];
    }
  }, {
    key: "wg",
    value: function wg(t, i, s) {
      if (null == this.hg) return !0;
      if (s === ot.qs) return E.info("Ignoring minimum interval between trigger because it is a test type."), !0;
      var e = t.hd;
      return null == e && (e = this.tg), i - this.hg >= 1e3 * e;
    }
  }, {
    key: "Tg",
    value: function Tg(t, i, e, r, h) {
      this.fg(), t.id && (this.ng[t.id] = this.ng[t.id] || []);
      var n = {};
      var o;
      n.Er = i, n.ug = e, null != r && (o = r.dt()), n.dg = o;
      var l = [];
      var _iterator2 = _createForOfIteratorHelper(h),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t13 = _step2.value;
          _t13.id && l.push(_t13.id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      n.pg = l, t.id && this.ng[t.id].push(n), this.j && this.j.ft(s.ct.EE, this.ng);
    }
  }, {
    key: "yg",
    value: function yg(t, i) {
      this.fg(), t.ad(i), this.hg = i, t.id && (this.og[t.id] = i), this.j && (this.j.ft(s.ct.iE, i), this.j.ft(s.ct.aE, this.og));
    }
  }]);
  return gr;
}(t);
export { gr as default };